<template>
  <div>
   <table style="width:90%">
      <tr>
        <td>
          <div style="float: left">
            <h1>{{ translateWords.querykey }}</h1>
          </div>
        </td>
        <td></td>
      </tr>
      <tr>
    
      </tr>
      <tr>
        <td>
              <div style="float: left; padding-left: 30px">{{translateWords.keyCode}}:
            <el-input
              style="width: 300px"
              v-model="key"
              :placeholder="translateWords.querypara"
            ></el-input>
            <el-button  type="primary" @click="query">{{
            translateWords.query
          }}</el-button>
          </div>
        </td>
             
      
      </tr>
    </table>


    <el-table :data="tableData" style="width:90%">
      <el-table-column prop="CreateBy" :label="translateWords.CreateBy"  width=100>
      </el-table-column>

 <el-table-column
        prop="CreateName"
        :label="translateWords.CreateName"
      >
      </el-table-column>
      <el-table-column
        prop="AppLyID"
        :label="translateWords.AppLyID"
      >
      </el-table-column>
       <el-table-column
        prop="StatusStr"
        :label="translateWords.StatusStr"
      >
      </el-table-column>
      <el-table-column   :formatter="dateFormat"    prop="CreateTime" :label="translateWords.CreateTime">
      </el-table-column>
      
    
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[10, 20, 30]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  
  </div>
</template>
<script>
import { importScript } from "../util/importScript";
export default {
  name: "SampleKeyRecord",
  data() {
    return {
      uid: this.$route.query.uid,
      token: this.$route.query.token,
      lang: this.$route.query.lang,
      total: 0,
      currPage: 1,
      pageSize: 10,
      isQuery: false,
      tableData: [],
      translateWords:{
              querykey:"查询钥匙",
              keyCode:"关键字",
              query:"查询",
              CreateBy:"工号",
              CreateName:"姓名",
              AppLyID:"借样工单号",
              StatusStr:"审批状态",
              CreateTime:"申请时间",
              querypara:"支持工号,姓名,ID关键字查询"

      },
      key:''
    };
  },
  mounted() {
    var that = this;
    importScript(this.baseurl, () => {
      that.jsT = window.jsT;
      that.translateWord();
    });
  },
  created: function () {
   this.getData(1,this.pageSize);
  },
  methods: {
    translateWord() {
      let that = this;
      if (this.jsT) {
        //翻译词条，覆盖默认的
        this.translateWords = {
          querykey:that.jsT.T(that.translateWords.querykey), 
          keyCode: that.jsT.T(that.translateWords.keyCode), 
          query: that.jsT.T(that.translateWords.query),
          CreateBy: that.jsT.T(that.translateWords.CreateBy),
            CreateName: that.jsT.T(that.translateWords.CreateName),
              AppLyID: that.jsT.T(that.translateWords.AppLyID),
                StatusStr: that.jsT.T(that.translateWords.StatusStr),
                  CreateTime: that.jsT.T(that.translateWords.CreateTime),
                  querypara: that.jsT.T(that.translateWords.querypara)
        };
      } else {
        console.log("翻译器没有加载成功");
      }
    },  
    dateFormat:function(row,column){
  var date = row[column.property]; 
  if (date === undefined) { 
    return ""; 
  } 
  var moment = require("moment");
  return moment(date).format("YYYY-MM-DD HH:mm:ss"); 
},
  handleSizeChange(val) {
      this.pageSize = val;
      this.currPage = 1;
      this.getData(this.currPage, this.pageSize);
    },
    handleCurrentChange(val) {
      this.currPage = val;
      this.getData(this.currPage, this.pageSize);
    },
    getData(index, size) {
      var params = new URLSearchParams();
      params.append("pageIndex", index);
      params.append("pageSize", size);
       params.append("lang", this.lang);
       params.append("uid", this.uid);
      params.append("cmd", "GetSampleKeyRecord");
      if (this.isQuery) {
        params.append("KeyCode", this.key);
      }
      this.$http.post(this.actionurl, params).then((res) => {
        this.tableData = res.data.Data.list;
        this.total = res.data.Data.total;
      });
    },  
    query() {
      this.isQuery = true;
      this.getData(1, this.pageSize);
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/SampleKeyRecord.vue